// extracted by mini-css-extract-plugin
module.exports = {"container":"Gallery_container__p27Hq","title":"Gallery_title__hGFLt","links":"Gallery_links__ktfwS","shareLinks":"Gallery_shareLinks__e5M1H"};